import HttpClientToken from '../../services/HttpClientToken';
import HttpClientApiKey from '../../services/HttpClientApiKey';
import HttpClientFormData from '../../services/HttpClientFormData';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AxiosError } from 'axios';

import { ActualizarEstatusParams, UnidadProps, UnidadResponse } from '../../interfaces/catalogos/UnidadInterface';

export const Unidades = () => {

    return new Promise<UnidadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.get('/Api/Unidad/', token)
            .then( ({ data } : { data : UnidadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerUnidades = () => {

    return new Promise<UnidadProps[]>( (resolve, eject) => {   

        HttpClientApiKey.get('/Api/Unidad/ObtenerUnidades')
        .then( ({ data } : { data : UnidadProps[] } ) => {               
            resolve( data );                
        })
        .catch( () => {
            resolve( [] );
        });        

    });

}

export const ActualizarUnidad = ( params: FormData ) => {

    return new Promise<UnidadResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientFormData.post('/Api/Unidad/Actualizar', params, token)
            .then( ({ data } : { data : UnidadResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError) => {
                resolve( {
                    success: false,
                    message: error.message,
                    idUnidad: 0,
                    imagen: '',
                    descripcion: '',
                    activo: false,         
                    referencia: 0,     
                });
            });
        }

    });

}

export const AgregarUnidad = ( params: FormData ) => {

    return new Promise<UnidadResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientFormData.post('/Api/Unidad/Agregar', params, token)
            .then( ({ data } : { data : UnidadResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError) => {
                resolve( {
                    success: false,
                    message: error.message,
                    idUnidad: 0,
                    imagen: '',
                    descripcion: '',
                    activo: false,         
                    referencia: 0,     
                });
            });
        }

    });

}

export const ActualizarEstatusUnidad = ( params: ActualizarEstatusParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.post('/Api/Unidad/ActualizarEstatus', params, token)
            .then( ({ data } : { data : HttpResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}